import React, {useCallback, useEffect, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemBrowser.module.css'
import {Alert, LinearProgress} from "@mui/material";
import {FixedSizeList} from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import ServerManager from "../../API/ServerManager";
import SurveysItemBrowserHeader from "./SurveysItemBrowserHeader";
import SurveysItemBrowserItem from "./SurveysItemBrowserItem";

const ITEMS_PER_RQ_PAGE = 30;
const TYPING_TIMEOUT = 500; // [ms]

const SurveysItemBrowser = ({
                                                filteredItems,
                                                setFilteredItems,
                                                refsData,
                                                setRefsData,
                                                selectedItemId,
                                                setSelectedItemId,
                                                setSearchByIdMode,
                                            }) => {

    const [totalItemCount, setTotalItemCount] = useState(-1);
    const [dateFromText, setDateFromText] = useState('');
    const [dateTillText, setDateTillText] = useState('');

    //----

    const rqIdCounter = useRef(0);
    const [status, setStatus] = useState(""); // "", idle, mainLoad, addLoad, mainError, typing
    const [mainErrorMessage, setMainErrorMessage] = useState("");
    const [lastTypingTime, setLastTypingTime] = useState(0);
    const [pagination, setPagination] = useState({is_last: true})
    const [refreshCounter, setRefreshCounter] = useState(0);


    // for call
    function onFilterEdit(forceUpdate = false) {
        setStatus("typing");
        setLastTypingTime(forceUpdate ? 0 : Date.now());
        setFilteredItems([]);
        setTotalItemCount(-1);
        rqIdCounter.current++;
    }

    // после первого рендера сразу запрашиваем первую порцию
    useEffect(() => {
        requestMainItems();

        // при анмоунте отменяем текущий запрос
        return () => {
            rqIdCounter.current++;
        }
    }, []);

    // for refresh
    useEffect(() => {
        if (refreshCounter > 0)
            requestMainItems();
    }, [refreshCounter]);


    async function requestMainItems() {

        if (dateFromText === "error" || dateTillText === "error")
        {
            setStatus("idle");
            return;
        }

        const extraParams = {};

        if (dateFromText)
            extraParams.from = dateFromText;

        if (dateTillText)
            extraParams.to = dateTillText;

        rqIdCounter.current++;
        const rqId = rqIdCounter.current;
        //console.log("rqId", rqId);

        setStatus("mainLoad")
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const data = await ServerManager.getSurveyFilteredList(ITEMS_PER_RQ_PAGE, 0, extraParams);
            if (rqIdCounter.current === rqId) {
                setFilteredItems(data["survey_responses"]);
                setRefsData(data.refs);
                setTotalItemCount(data.total);
                setPagination(data.pagination);
                setStatus("idle");
            }
        } catch (error) {
            if (rqIdCounter.current === rqId) {
                setMainErrorMessage(`Ошибка при загрузке данных: ${error}`);
                setStatus("mainError");
            }
        } finally {
            if (rqIdCounter.current !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    async function requestMoreItems() {
        const extraParams = {};

        if (dateFromText)
            extraParams.from = dateFromText;

        if (dateTillText)
            extraParams.to = dateTillText;

        rqIdCounter.current++;
        const rqId = rqIdCounter.current;
        //console.log("rqId", rqId);

        setStatus("addLoad")
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const data = await ServerManager.getSurveyFilteredList(ITEMS_PER_RQ_PAGE, pagination.next_offset, extraParams);
            if (rqIdCounter.current === rqId) {
                setFilteredItems([...filteredItems, ...data["survey_responses"]]);
                setRefsData(mergeRefDatas(refsData, data.refs));
                setPagination(data.pagination);
                setStatus("idle");
            }
        } catch (error) {
            if (rqIdCounter.current === rqId) {
                //setMainErrorMessage(`Ошибка при загрузке данных: ${error}`); // TODO popup?
                setStatus("idle");
            }
        } finally {
            if (rqIdCounter.current !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    // запуск/продление временной задержки во время ввода текста
    useEffect(() => {
        async function wait() {
            const leftTime = lastTypingTime + TYPING_TIMEOUT - Date.now();
            if (leftTime > 0)
                await new Promise(resolve => setTimeout(resolve, leftTime));
            if (!ignore)
                requestMainItems();
        }

        if (status !== "typing")
            return;

        let ignore = false;
        wait();
        return () => {
            ignore = true;
        }

    }, [status, lastTypingTime]);

    function renderListRow({index, style, data}) {

        const item = data[index];

        return (
            <SurveysItemBrowserItem
                style={style}
                id={item.id}
                title={item.user_email}
                subtitle={extractDate(item)}
                selected={item.id === selectedItemId}
                onClick={() => {
                    setSearchByIdMode(false);
                    setSelectedItemId(item.id);
                }}
            />
        );
    }

    function getListItemKey(index, data) {
        return data[index].id;
    }

    function onSearchById(id) {
        setSearchByIdMode(true);
        setSelectedItemId(id);
    }

    return (<div className={cl.main}>
        <SurveysItemBrowserHeader
            totalItemCount={totalItemCount}
            onFilterEdit={onFilterEdit}
            onSearchById={onSearchById}
            dateFromText={dateFromText}
            setDateFromText={setDateFromText}
            dateTillText={dateTillText}
            setDateTillText={setDateTillText}
        />
        {(status === "mainLoad" || status === "typing") && <LinearProgress/>}
        {status === "mainError" && <Alert variant="outlined" severity="error">{mainErrorMessage}</Alert>}
        {filteredItems.length > 0 &&
            <div className={cl.itemList}>
                <MyList
                    filteredItems={filteredItems}
                    getListItemKey={getListItemKey}
                    renderListRow={renderListRow}
                    selectedItemId={selectedItemId}
                    requestMoreItems={requestMoreItems}
                    pagination={status === "idle" ? pagination : null}
                    refreshCounter={refreshCounter}
                />
            </div>}
    </div>);
};

const MyList = ({
                    filteredItems,
                    getListItemKey,
                    renderListRow,
                    selectedItemId,
                    requestMoreItems,
                    pagination,
                    refreshCounter
                }) => {

    const listRef = useCallback(node => {
        //console.log(">>> cb", "node=", node)
        if (node !== null) {
            if (selectedItemId) {
                const item = filteredItems.find(x => x.id === selectedItemId);
                if (item) {
                    node.scrollToItem(filteredItems.indexOf(item), "smart");
                }
            }
        }
        //}, [filteredItems, selectedItemId, sortType, refreshCounter]);
    }, [selectedItemId, refreshCounter]);

    return <AutoSizer>
        {({height, width}) => (
            <FixedSizeList
                ref={listRef}
                width={width}
                height={height}
                itemCount={filteredItems.length}
                itemSize={110}
                overscanCount={150}
                itemData={filteredItems}
                itemKey={getListItemKey}
                onItemsRendered={({visibleStopIndex}) => {
                    if (pagination && !pagination.is_last && visibleStopIndex + 1 >= filteredItems.length) {
                        requestMoreItems();
                    }
                }}
            >
                {renderListRow}
            </FixedSizeList>)}
    </AutoSizer>
}

//------

// tool
function mergeRefDatas(refData1, refData2) {
    if (!refData1)
        return refData2;

    if (!refData2)
        return refData1;

    return  deepMerge(refData1, refData2);
}

// tool (from internet)
// TODO! check!
function deepMerge(target, source) {
    // Create a deep copy of the target to avoid mutation of the original object
    const output = {...target};

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key]) && target[key]) {
                // If both are objects, merge recursively
                output[key] = deepMerge(target[key], source[key]);
            } else {
                // Otherwise, use the source value (overwrites target's primitives/arrays)
                output[key] = source[key];
            }
        }
    }

    return output;
}

// tool (from internet)
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function extractDate(item) {
    if (!item || !item.created_at)
        return "";

    // "2026-07-09T21:21:22.493691+03:00"
    const regex = /^(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d:\d\d)/;
    const match = regex.exec(item.created_at);
    if (!match)
        return "";

    return `${match[3]}.${match[2]}.${match[1]} ${match[4]}`;
}

export default SurveysItemBrowser;